export default __webpack_public_path__ + "static/media/Chestplate of the Milites Templi.184ec492.jpg";